
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getEmailTemplates",
      resolverType: "query",
      routePath: "/getEmailTemplates",
      httpMethod: "POST",
    });
  